import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"functions-1"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M11 4H4C3.44772 4 3 4.44772 3 5V12M3 12H11M3 12V20","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M21 11L21 12.1363C21 12.4345 20.8669 12.7171 20.6371 12.9071L17.5 15.5M14 11L14 12.1363C14 12.4345 14.1331 12.7171 14.3629 12.9071L17.5 15.5M17.5 15.5L14.3629 18.0929C14.1331 18.2829 14 18.5655 14 18.8637L14 20M17.5 15.5L20.6371 18.0929C20.8669 18.2829 21 18.5655 21 18.8637L21 20","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Functions1 = Vue.extend<IconProps>({
  name: 'Functions1Icon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'functions-1',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Functions1;
